(function () {
  'use strict';

  function productsFactory (apiFactory, $rootScope, odrDistributionFactory, whereToFactory, distributionFactory) {
    const factory = {};
    factory.rawProducts = [];
    factory.products = [];

    function fetchProducts (updateList = false, callback = () => { }, deliverDate = undefined) {
      if (updateList || factory.products.length === 0) {
        const recipientsCount = whereToFactory.getRecipientsCount();
        const userType = $rootScope.isNCPUser() ? 'company' : 'public';

        const data = {
          'language': pnTopbar.language,
          'country': pnTopbar.market,
          'userType': userType,
          'recipientsCount': recipientsCount,
          'deliveryDate': deliverDate
        };

        getProducts(data, callback);
      } else {
        if (callback) {
          callback(); // just in case it gives error because there is no callback being set as parameter
        }
      }
    }

    function getProducts (data, callback) {
      if (factory.rawProducts.length > 0) {
        factory.products = whereToFactory.restructureProducts(factory.rawProducts);
        callback();
      } else {
        apiFactory.getProducts.post(data).$promise
        .then(function (res) {
          factory.rawProducts = res.products;
          factory.products = whereToFactory.restructureProducts(res.products);
          callback();
        }, function (err) {
          console.log(err);
        });
      }
    }

    function getDefaultProductDelivery () {
      return factory.rawProducts.length ? whereToFactory.restructureProducts(factory.rawProducts)[0] : {};
    }

    function getAvailableOptionId (addressType, options) {
      let filteredOptions = angular.copy(options);

      if (addressType === 'ODR' || addressType === 'ADR') {
        filteredOptions = options.filter((item) => {
          return (!item.addressType && addressType === 'ADR') || item.addressType === addressType;
        });
      }

      const filterOptionsCpy = angular.copy(filteredOptions); // this is to preserve addresst type filtered array

      filteredOptions = filteredOptions.filter((item) => {
        return !item.postageProducts || (item.postageProducts && item.postageProducts.length > 0);
      });

      return filteredOptions.length ? filteredOptions[0].id : filterOptionsCpy[0].id;
    }

    factory.fetchProducts = fetchProducts;
    factory.getDefaultProductDelivery = getDefaultProductDelivery;
    factory.getAvailableOptionId = getAvailableOptionId;
    factory.getODRCenters = odrDistributionFactory.getODRCenters;

    return factory;
  }

  angular.module('web2print.recipients')
    .factory('productsFactory', productsFactory);

  productsFactory.$inject = ['apiFactory', '$rootScope', 'odrDistributionFactory', 'whereToFactory', 'distributionFactory'];
})();
